import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconCheckmark = createIcon({
  viewBox: '0 0 100 100',
  path: (
    <>
      <defs>
        <path
          id="xusgj0qzza"
          d="M33.333 0c18.41 0 33.334 14.924 33.334 33.333 0 18.41-14.924 33.334-33.334 33.334C14.923 66.667 0 51.743 0 33.333 0 14.923 14.924 0 33.333 0zm15.894 23.687c-1.031-1.027-2.703-1.027-3.734 0L29.208 39.903l-8.034-8c-1.031-1.027-2.703-1.027-3.734 0-1.031 1.026-1.031 2.691 0 3.718l9.901 9.859c1.031 1.027 2.703 1.027 3.734 0l18.152-18.075c1.03-1.027 1.03-2.692 0-3.718z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                d="M0 0H100V100H0z"
                transform="translate(-132 -124) translate(24 124) translate(108)"
              />
              <g transform="translate(-132 -124) translate(24 124) translate(108) translate(16.667 16.667)">
                <mask id="37ftw7k30b" fill="#fff">
                  <use xlinkHref="#xusgj0qzza" />
                </mask>
                <use fill="#3EA69B" xlinkHref="#xusgj0qzza" />
                <g fill="#3EA69B" mask="url(#37ftw7k30b)">
                  <path
                    d="M0 0H333.333V333.333H0z"
                    transform="translate(-133.333 -133.333)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </>
  ),
});

export default IconCheckmark;
